export default "__VITE_ASSET__BMPLh5U$__"